import { render, staticRenderFns } from "./TabsOffer.vue?vue&type=template&id=5736782a&scoped=true"
import script from "./TabsOffer.vue?vue&type=script&lang=js"
export * from "./TabsOffer.vue?vue&type=script&lang=js"
import style0 from "./TabsOffer.vue?vue&type=style&index=0&id=5736782a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5736782a",
  null
  
)

export default component.exports